import { Routes } from "@angular/router";
import { authGuard } from "./guards/auth.guard";
import { loginGuard } from "./guards/auth-login.guard";
import { permissionGuard } from "./guards/permission.guard";

export const routes: Routes = [
  {
    path: "landing",
    title: "Delivery One",
    loadComponent: () => import("./landing/landing.component").then((c) => c.LandingComponent),
  },
  {
    path: "landing/about",
    title: "Delivery One",
    loadComponent: () =>
      import("./landing/about/about-landing/about-landing.component").then(
        (c) => c.AboutLandingComponent
      ),
  },
  { path: "", pathMatch: "full", redirectTo: "login" },
  {
    path: "login",
    canMatch: [loginGuard],
    title: "Iniciar Sesión - Delivery One",
    loadComponent: () =>
      import("./login/feature/login-page/login-page.component").then((c) => c.LoginPageComponent),
  },
  {
    path: "reset-password/:token",
    title: "Restablecer Contraseña - Delivery One",
    loadComponent: () =>
      import("./reset-password/feature/reset-password.component").then(
        (c) => c.ResetPasswordComponent
      ),
  },
  {
    path: "admin",
    canActivate: [authGuard],
    loadComponent: () =>
      import("./admin/ui/layout/layout.component").then((m) => m.LayoutComponent),
    children: [
      {
        path: "dashboard",
        title: "Dashboard - Delivery One",
        loadComponent: () =>
          import("./dashboard/feature/dashboard/dashboard.component").then(
            (d) => d.DashboardComponent
          ),
      },
      {
        path: "billing",
        title: "Facturación - Delivery One",
        canActivate: [permissionGuard("billing")],
        loadComponent: () =>
          import("./billing/feature/billing-page/billing-page.component").then(
            (b) => b.BillingPageComponent
          ),
      },
      {
        path: "notifications",
        title: "Notificaciones - Delivery One",
        loadComponent: () =>
          import("./notifications/feature/notifications-page/notifications-page.component").then(
            (n) => n.NotificationsPageComponent
          ),
      },
      {
        path: "conversations",
        title: "Conversaciones - Delivery One",
        loadComponent: () =>
          import("./conversations/feature/conversations-view/conversations-view.component").then(
            (c) => c.ConversationsViewComponent
          ),
      },
      {
        path: "delivery",
        title: "Pedidos a entregar - Delivery One",
        loadComponent: () =>
          import("./delivery/feature/delivery-list/delivery-list.component").then(
            (d) => d.DeliveryListComponent
          ),
      },
      {
        path: "customers",
        title: "Clientes - Delivery One",
        loadComponent: () =>
          import("./customers/feature/customer-list/customer-list.component").then(
            (c) => c.CustomerListComponent
          ),
      },
      {
        path: "delivery/:id",
        title: "Detalle Entrega - Delivery One",
        loadComponent: () =>
          import("./delivery/feature/delivery-detail/delivery-detail.component").then(
            (d) => d.DeliveryDetailComponent
          ),
      },
      {
        path: "settings",
        title: "Configuración - Delivery One",
        loadComponent: () =>
          import("./settings/feature/settings-page/settings-page.component").then(
            (s) => s.SettingsPageComponent
          ),
      },
      {
        path: "zones",
        title: "Zona de Cobertura - Delivery One",
        loadComponent: () =>
          import("./zones/feature/zone-editor/zone-editor.component").then(
            (z) => z.ZoneEditorComponent
          ),
      },
      {
        path: "payment-methods",
        title: "Métodos de pago - Delivery One",
        loadComponent: () =>
          import("./payment-methods/feature/payment-methods-page.component").then(
            (p) => p.PaymentMethodsPageComponent
          ),
      },
      {
        path: "schedule",
        title: "Horarios - Delivery One",
        loadComponent: () =>
          import("./schedule/feature/schedule-page.component").then((s) => s.SchedulePageComponent),
      },
      {
        path: "orders",
        title: "Pedidos - Delivery One",
        loadComponent: () =>
          import("./orders/feature/orders-list/orders-list.component").then(
            (o) => o.OrdersListComponent
          ),
      },
      {
        path: "orders/:id",
        title: "Detalle Pedido - Delivery One",
        loadComponent: () =>
          import("./orders/feature/order-detail/order-detail.component").then(
            (o) => o.OrderDetailComponent
          ),
      },
      {
        path: "products",
        title: "Productos - Delivery One",
        loadComponent: () =>
          import("./products/feature/product-list/product-list.component").then(
            (p) => p.ProductListComponent
          ),
      },
      {
        path: "products/create",
        title: "Crear Producto - Delivery One",
        loadComponent: () =>
          import("./products/feature/product-form/product-form.component").then(
            (p) => p.ProductFormComponent
          ),
      },
      {
        path: "products/edit/:id",
        title: "Editar Producto - Delivery One",
        loadComponent: () =>
          import("./products/feature/product-form/product-form.component").then(
            (p) => p.ProductFormComponent
          ),
      },
      {
        path: "products/:id",
        title: "Detalle Producto - Delivery One",
        loadComponent: () =>
          import("./products/feature/product-detail/product-detail.component").then(
            (p) => p.ProductDetailComponent
          ),
      },
      {
        path: "products/:id/composition",
        title: "Composición - Delivery One",
        loadComponent: () =>
          import("./products/feature/composition-editor/composition-editor.component").then(
            (p) => p.CompositionEditorComponent
          ),
      },
      {
        path: "options",
        title: "Opciones - Delivery One",
        loadComponent: () =>
          import("./products/feature/option-catalog/option-catalog.component").then(
            (o) => o.OptionCatalogComponent
          ),
      },
      {
        path: "options/create",
        title: "Crear Opción - Delivery One",
        loadComponent: () =>
          import("./products/feature/option-form/option-form.component").then(
            (o) => o.OptionFormComponent
          ),
      },
      {
        path: "options/edit/:id",
        title: "Editar Opción - Delivery One",
        loadComponent: () =>
          import("./products/feature/option-form/option-form.component").then(
            (o) => o.OptionFormComponent
          ),
      },
      {
        path: "users",
        title: "Usuarios - Delivery One",
        loadComponent: () =>
          import("./users/feature/user/user.component").then((u) => u.UserComponent),
      },
      {
        path: "users/create",
        title: "Crear usuario - Delivery One",
        loadComponent: () =>
          import("./users/feature/user-form/user-form.component").then((u) => u.UserFormComponent),
      },
      {
        path: "users/edit/:id",
        title: "Editar usuario - Delivery One",
        loadComponent: () =>
          import("./users/feature/user-form/user-form.component").then((u) => u.UserFormComponent),
      },
      {
        path: "perfil",
        title: "Perfil - Delivery One",
        loadComponent: () =>
          import("./profile/feature/profile/profile.component").then((p) => p.ProfileComponent),
      },
      {
        path: "earnings",
        title: "Cierre del día - Delivery One",
        loadComponent: () =>
          import("./earnings/feature/earnings-list/earnings.component").then(
            (e) => e.EarningsComponent
          ),
      },
      {
        path: "earnings/detail",
        title: "Ver cierre del día - Delivery One",
        loadComponent: () =>
          import("./earnings/feature/earnings-detail/earnings-detail.component").then(
            (e) => e.EarningsDetailComponent
          ),
      },
      {
        path: "delivery-settlement",
        title: "Liquidación de pagos - Delivery One",
        loadComponent: () =>
          import("./delivery/feature/delivery-settlement/delivery-settlement.component").then(
            (c) => c.DeliverySettlementComponent
          ),
      },
      {
        path: "landing-config",
        title: "Configuración - Delivery One",
        loadComponent: () =>
          import("./landing-config/landing-config.component").then((e) => e.LandingConfigComponent),
      },
      {
        path: "digital-menu",
        title: "Menú Digital - Delivery One",
        canActivate: [permissionGuard("products")],
        loadComponent: () =>
          import("./digital-menu/feature/digital-menu-page/digital-menu-page.component").then(
            (d) => d.DigitalMenuPageComponent
          ),
      },
      {
        path: "pricing",
        title: "Precios y domicilio - Delivery One",
        canActivate: [permissionGuard("products")],
        loadComponent: () =>
          import("./pricing/feature/pricing-page/pricing-page.component").then(
            (p) => p.PricingPageComponent
          ),
      },
      {
        path: "history/orders",
        title: "Historial de órdenes - Delivery One",
        canActivate: [permissionGuard("orders")],
        loadComponent: () =>
          import("./orders/feature/orders-history/orders-history.component").then(
            (p) => p.OrdersHistoryComponent
          ),
      },
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
    ],
  },
  {
    path: "**",
    title: "Página no encontrada - Delivery One",
    loadComponent: () =>
      import("./shared/pages/not-found/not-found.component").then((m) => m.NotFoundComponent),
  },
];
